<template>
    <div>
        <div style="text-align: left">
            <div class="searchbarcls">
                部门名称:<el-input  size="small" v-model="searchForm.departmentName"  style="width: 200px;"></el-input>
                &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="">查询</el-button>
            </div>
            <div style="padding: 2px;">
                <el-button type="primary" plain style="height: 30px" size="small" @click="">新 增</el-button>
            </div>
        </div>
        <el-table
            ref="myElTable"
            background="true"
            :data="tableData"
            :height="clientHeight-otherHeight"
            @row-click=""
            border style="width: 100%;">
            <el-table-column type="selection" width="42"/>
            <el-table-column type="index" label="序号"  width="50"/>
            <el-table-column prop="tenantPid" label="企业编号" width="165"/>
            <el-table-column prop="tenantName" label="企业名称" width="310"/>
            <el-table-column prop="tenantTypeName" label="企业类型" width="130"/>
            <el-table-column prop="districtName" label="所属区域" width="130"/>
            <el-table-column prop="tenantPeople" label="联系人" width="130"/>
            <el-table-column prop="thephone" label="联系电话" />
            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" plain @click="">编辑</el-button>
                    <el-button type="danger" size="mini" plain @click="">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change=""
                @current-change=""
                :current-page="searchForm.currPage"
                :page-sizes="[20, 30, 40]"
                :page-size="20"
                layout="total,jumper, prev, pager, next,sizes"
                :total="searchForm.dataTotal">
        </el-pagination>

    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        props: {
            clientHeight: {
                type: Number
            }
        },
        data() {
            return {
                otherHeight:210,
                drawer: false,
                udrawer: false,
                departmentData:{},
                searchForm: {
                    dataTotal:0,
                    pageSize:20,
                    currPage:1,
                    departmentName:''
                },
                tableData: []
            }
        },
        created() {
            this.loadTableData();
        },
        methods:{
            loadTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.searchForm;
                appjs.httpRequest('tenant/queryTenant',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.searchForm.dataTotal = data.totalRowNum;
                            _self.tableData = data.dataList;
                            this.$refs.myElTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
            },
        }
    }
</script>
